// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xNIv","toggle":"styles_toggle__3V1oQ","preview":"styles_preview__33XS9"};